//import { Component, OnInit } from '@angular/core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { DepartmentsService } from 'src/app/services/departments.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UserService } from 'src/app/services/user.service';
import { Profile } from 'src/app/models/profile';
import { EmployeeExitClearanceVm } from 'src/app/models/requests/ExitClearanceRequestVM';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationType } from 'src/app/models/notification.message';
import { ReasonsService } from 'src/app/services/reasons.service';
import { LocationDto } from 'src/app/models/LocationDto';
import { LocationsService } from 'src/app/services/locations.service';
@Component({
  selector: 'app-new-exitclearance',
  templateUrl: './new-exitclearance.component.html',
  styleUrls: ['./new-exitclearance.component.css']
})
export class NewExitclearanceComponent implements OnInit {
  @ViewChild('ngNewExitForm') theForm: any;

  
  clicked : boolean = false;
  selectedFunctionId: string = ''
  selectedUserId: string = ''
  selectedRequesterFunctionId: string = ''
  employeeName: string = ''
  designation: string = '';
  sapNumber: string = '';
  lapEmail:string='';
  selectedDepartmentId: string = ''
  selectedLocationId: string = ''
  Functions:FunctionDto[]=[];
  Locations:LocationDto[]=[];
  Departments: DepartmentDto[] = [];
  personalPhoneNumber: string = '';
  personalEmail: string = '';
  permanentAddress: string = '';
  NeedMedicalWaiver: boolean = false;
 lastWorkingDate: Date | null = null;
 HRBPS:Profile[]=[];
 selectedhrbpId:string="";
 selectedManagerId:string="";
 Managers:Profile[]=[];
 employeeUnitName :string="";
 employeeFunctionName:string="";
 employeeLocationName :string="";
 SelectedDepartment:DepartmentDto | null = null;
 SelectedDepartmentId: number| undefined=0;
 SelectedDepartmentName:string="";
 SelectedLocationId: number| undefined=0;
 SelectedLocationName:string="";
 SelectedUnit:FunctionDto |null =null;
 selectedHRBP:Profile|null =null;
 SelectedLM:Profile|null =null;
 Allusers:Profile[]=[];
 filteredUsers: Profile[]=[];
 selectedUser: Profile | null = null;
 selectedReason: any;
unitId?: number;
functionId?: number; 
locationId?: number; 
dropdownData: any[] = [];
  
  constructor(  private notification: NotificationService, private department: DepartmentsService, private nznotification: NzNotificationService, private tokenService: TokenService,
    private functionService:FunctionsService ,  private userService: UserService, private exitClearanceService:ExitClearanceService, private reasonsService: ReasonsService,
    private locationService: LocationsService
   ) { }

  ngOnInit(): void {
    this.LoadDropDowns()
  }


  onSubmit(): void 
  {
//;
    let exitRequest : EmployeeExitClearanceVm={
      EmployeeSAPId:this.sapNumber,
      EmployeeLAPEmail: this.lapEmail,
      EmployeeName: this.employeeName,
      EmployeeUnitId : this.unitId,
      EmployeeUnitName : this.employeeUnitName,
      EmployeeFunctionId: this.functionId,
      EmployeeFunctionName : this.SelectedDepartmentName,
      EmployeeLocationId: this.locationId,
      Location: this.SelectedLocationName,
      EmployeeDesignation: this.designation,
      EmployeePhoneNumber: this.personalPhoneNumber,
      EmployeePersonalEmail: this.personalEmail,
      EmployeePermanentAddress : this.permanentAddress,
      EmployeeLastWorkingDate : this.lastWorkingDate,
      ReasonForExit : this.selectedReason,
      LineManagerEmail: this.SelectedLM?.email,
      LineManagerName: this.SelectedLM?.firstName + " " + this.SelectedLM?.lastName ,
      HRBPEmail: this .selectedHRBP?.email,
      HRBPName: this.selectedHRBP?.firstName + " " + this.selectedHRBP?.lastName   
      // NeedMedicalWaiver: this.NeedMedicalWaiver
    };

    this.exitClearanceService.crateExitform(exitRequest).subscribe({
      next: (data => {
        //
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Exit Clearance initiated successfully.`,
            type: NotificationType.success
          });
        
          this.theForm.resetForm();
          this.clicked = false;
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.clicked = false;
        }

      }),
      error: ((error: any) => {
        console.log(error.error);
     //   ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.clicked = false;
      })

    });
  }
    onUnitChange(value: any)
{
  //;
  //console.log(this.SelectedUnit);
 //this. employeeUnitName= value.target.value;

}onUserChange(value:any){
  
  var email =  this.selectedUser?.email;
  this.unitId = this.selectedUser?.functionId || 0;
  var departmentName = this.selectedUser?.functionName || '';
  var functionName = this.selectedUser?.departmentName || '';
  this.functionId = this.selectedUser?.departmentId || 0;
  var locationName = this.selectedUser?.locationName || '';
  this.locationId = this.selectedUser?.locationId || 0;
  var sapId = this.selectedUser?.sapId || '';
  var employeeFName = this.selectedUser?.firstName || '';
  var employeeLName = this.selectedUser?.lastName || '';
  
  if(email){
    this.lapEmail = email;
    this.employeeUnitName = departmentName;
    this.SelectedDepartmentName = functionName;
    this.SelectedLocationName = locationName;
    this.sapNumber = sapId;
    this.employeeName = `${employeeFName} ${employeeLName}`;

    if (this.selectedUser?.designationName != null || this.selectedUser?.designationName != undefined || this.selectedUser?.designationName != '') {
      this.designation = this.selectedUser?.designationName || '';
    }
  }
  
}
onLMChange(value:any)
{
  ;
  console.log(this.SelectedLM)
}
onHRBPChange(value:any)
{
  //;
  //console.log(this.selectedHRBP);
}
onDeptChange(value: any)
{
//;

 
 //let num: number | undefined = this.SelectedDepartment?.id;
 //this.SelectedDepartmentId=num;
 //console.log(this.SelectedDepartment)
 //;

}
  async LoadDropDowns() {

      let users = await this.userService.getUsers().toPromise();
     this.Allusers = <Profile[]>users?.responseData;
     this.filteredUsers = this.Allusers;

    // let resDeparts = await this.department.getDepartments().toPromise();
    // this.Departments = <DepartmentDto[]>resDeparts.responseData;

    
    // let functions = await this.functionService.getAllFunctions().toPromise();
    // this.Functions = <FunctionDto[]>functions.responseData;

    // let locations = await this.locationService.getLocations().toPromise();
    // this.Locations = <LocationDto[]>locations.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;

    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    this.reasonsService.getReasons().subscribe((data) => {
    this.dropdownData = data || this.reasonsService.getLocalReasons()});
  }


  onCancel(){
    
    location.reload();
  }
}
